import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { useMetaRobots } from './hooks/useMetaRobots';

export const MetaRobots: React.FC = () => {
	const {
		data: { indexed },
	} = useMetaRobots();

	if (indexed) return null;

	return (
		<Helmet>
			<meta name="robots" content="noindex" />
		</Helmet>
	);
};
